import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { Button, Dialog, Text } from "@chakra-ui/react";
import { useDispatch } from "react-redux";

import { useLoader } from "@shared/hooks/LoaderHook";
import { FileUpload, CloseButton } from "@shared/components";
import { actions } from "@containers/Cases/store";
import { updateModal } from "@shared/store/actions";

interface CreateCaseModalProps {
  onClose: () => void;
  onSubmit: (fileBase64: string, fileName: string) => void;
}

const MAX_FILE_SIZE = 15;
export const ACCEPT_FILE_TYPES = ["pdf"];

const CreateCaseModal: FC<CreateCaseModalProps> = ({ onClose, onSubmit }) => {
  const [fileBase64, setFileBase64] = useState<string | null>(null);
  const [fileName, setFileName] = useState("");
  const dispatch = useDispatch();

  const handleUploadFile = useCallback((base64: string, file: File) => {
    setFileBase64(base64);
    setFileName(file.name);
  }, []);

  useEffect(() => {
    if (fileBase64) {
      dispatch(updateModal({ size: undefined }));
    } else {
      dispatch(updateModal({ size: "uploadPopup" }));
    }
  }, [dispatch, fileBase64]);

  const { isLoading } = useLoader({
    name: "createCase",
    actionTypes: useMemo(() => [actions.createCase], []),
  });

  return (
    <>
      <Dialog.Header>
        <Text textStyle="modalTitle" mt={2}>
          Upload Presentence Investigation Report
        </Text>
        <Dialog.CloseTrigger asChild>
          <CloseButton color="grey.10" />
        </Dialog.CloseTrigger>
      </Dialog.Header>
      <Dialog.Body mb={!fileBase64 ? 4 : undefined}>
        <FileUpload types={ACCEPT_FILE_TYPES} maxFileSize={MAX_FILE_SIZE} onUploadFile={handleUploadFile} />
      </Dialog.Body>
      {fileBase64 && (
        <Dialog.Footer>
          <Button variant="cancel" mr={3} onClick={() => onClose()} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={isLoading || !fileBase64}
            onClick={() => (fileBase64 ? onSubmit(fileBase64, fileName) : undefined)}
          >
            Save
          </Button>
        </Dialog.Footer>
      )}
    </>
  );
};

export default CreateCaseModal;
